export declare namespace AppBannerTokenSections {
	interface Icon {
		color: string;
		fontSize: string;
	}

	interface Text {
		fontSize: string;
		lineHeight: string;
		color: string;
	}

	interface Card {
		bodyGap: string;
		title: {
			fontSize: string;
			lineHeight: string;
			fontWeight: string;
			color: string;
		};
	}
}

export type AppBannerTokens = {
	paddingLeft: string;
	gap: string;
	alignItems: string;
	icon: AppBannerTokenSections.Icon;
	text: AppBannerTokenSections.Text;
	card: AppBannerTokenSections.Card;
};

/** Leading `<i class="pi …">` — color and size only; no wrapper background. */
export const icon: AppBannerTokenSections.Icon = {
	color: '{primary.500}',
	fontSize: '24px',
};

export const text: AppBannerTokenSections.Text = {
	fontSize: '16px',
	lineHeight: '26px',
	color: '{surface.950}',
};

/** Card variant (kicks in when `title` is set): bold title row + description below. */
export const card: AppBannerTokenSections.Card = {
	bodyGap: '8px',
	title: {
		fontSize: '18px',
		lineHeight: '28px',
		fontWeight: '700',
		color: '{surface.950}',
	},
};

/** Info-style banner — blue-tinted leading icon + dark text inline. */
export default {
	paddingLeft: '0',
	gap: '16px',
	alignItems: 'center',
	icon,
	text,
	card,
} satisfies AppBannerTokens;
